(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const section = document.getElementById('custom-slideshow-section');
  const slidesWrapper = section.querySelector('.slides-wrapper');
  const slides = slidesWrapper.querySelectorAll('.slide');
  const dots = section.querySelectorAll('.slideshow-dots span');
  let currentIndex = 0;
  const totalSlides = slides.length;
  const autoPlayInterval = 7000;

  slidesWrapper.querySelectorAll("img").forEach(img => {
    img.addEventListener("dragstart", e => e.preventDefault());
  });

  /* --------------------------
     Swap Image for Mobile
  -------------------------- */
  function swapMobileImages() {
    const isMobile = window.innerWidth <= 767;
    slides.forEach(slide => {
      const img = slide.querySelector('img:not(.slide-ornament-overlay img)');
      if (!img) return;
      const desktopSrc = img.getAttribute('data-desktop');
      const mobileSrc = img.getAttribute('data-mobile');
      img.src = isMobile && mobileSrc ? mobileSrc : desktopSrc;
    });
  }

  swapMobileImages();
  window.addEventListener('resize', swapMobileImages);

  /* --------------------------
     Dots + Slide Function
  -------------------------- */
  function updateDots(index) {
    dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
  }

  function goToSlide(index) {
    currentIndex = index;
    slidesWrapper.style.transform = `translateX(-${index * 100}%)`;
    updateDots(currentIndex);
  }

  /* --------------------------
     Autoplay
  -------------------------- */
  let autoPlayTimer = setInterval(() => {
    currentIndex = (currentIndex + 1) % totalSlides;
    goToSlide(currentIndex);
  }, autoPlayInterval);

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      clearInterval(autoPlayTimer);
      goToSlide(i);
      autoPlayTimer = setInterval(() => {
        currentIndex = (currentIndex + 1) % totalSlides;
        goToSlide(currentIndex);
      }, autoPlayInterval);
    });
  });

  /* --------------------------
     ✨ Swipe / Drag 支援
  -------------------------- */

  let startX = 0;
  let isDragging = false;
  let currentTranslate = 0;

  const threshold = 50; // 最少滑動距離才切換

  // 手指／滑鼠開始
  function startDrag(x) {
    clearInterval(autoPlayTimer);
    isDragging = true;
    startX = x;
    currentTranslate = -currentIndex * slidesWrapper.clientWidth;
  }

  // 移動中
  function moveDrag(x) {
    if (!isDragging) return;
    const diff = x - startX;
    slidesWrapper.style.transition = "none";
    slidesWrapper.style.transform = `translateX(${currentTranslate + diff}px)`;
  }

  // 結束
  function endDrag(x) {
    if (!isDragging) return;
    isDragging = false;

    const diff = x - startX;

    // 超過閾值 → 切換
    if (diff > threshold && currentIndex > 0) {
      currentIndex--;
    } else if (diff < -threshold && currentIndex < totalSlides - 1) {
      currentIndex++;
    }

    slidesWrapper.style.transition = "transform 0.6s ease";
    goToSlide(currentIndex);

    autoPlayTimer = setInterval(() => {
      currentIndex = (currentIndex + 1) % totalSlides;
      goToSlide(currentIndex);
    }, autoPlayInterval);
  }

  /* --------------------------
     Mouse Events
  -------------------------- */
  slidesWrapper.addEventListener("mousedown", e => startDrag(e.clientX));
  slidesWrapper.addEventListener("mousemove", e => moveDrag(e.clientX));
  slidesWrapper.addEventListener("mouseup", e => endDrag(e.clientX));
  slidesWrapper.addEventListener("mouseleave", e => endDrag(e.clientX));

  /* --------------------------
     Touch Events
  -------------------------- */
  slidesWrapper.addEventListener("touchstart", e => startDrag(e.touches[0].clientX));
  slidesWrapper.addEventListener("touchmove", e => moveDrag(e.touches[0].clientX));
  slidesWrapper.addEventListener("touchend", e => endDrag(e.changedTouches[0].clientX));

  goToSlide(0);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var forgotLink = document.getElementById('forgot-password-link');
  var backLink = document.getElementById('back-to-login');
  var loginCard = document.getElementById('login-card');
  var recoverCard = document.getElementById('recover-card');

  function showCard(cardToShow, cardToHide) {
    cardToHide.classList.add('hidden');
    setTimeout(function(){
      cardToShow.classList.remove('hidden');
    }, 50); // 延遲一點，確保 transition 可見
  }

  if(forgotLink) {
    forgotLink.addEventListener('click', function(e){
      e.preventDefault();
      showCard(recoverCard, loginCard);
    });
  }

  if(backLink) {
    backLink.addEventListener('click', function(e){
      e.preventDefault();
      showCard(loginCard, recoverCard);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-collection"]) return;
  try {
    
const url = new URL(window.location.href);
if (url.hash) {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    },
    { once: true }
  );
}

  } catch(e) { console.error(e); }
})();
})();
